// Configuración de PayPal
// IMPORTANTE: Reemplaza con tu Client ID de PayPal
// Para obtenerlo: https://developer.paypal.com/dashboard/applications/sandbox

export const PAYPAL_CLIENT_ID = import.meta.env.VITE_PAYPAL_CLIENT_ID || "test";

export const PAYPAL_OPTIONS = {
  clientId: PAYPAL_CLIENT_ID,
  currency: "USD",
  intent: "capture",
};

// Opciones de estilo para los botones de PayPal
export const PAYPAL_BUTTON_STYLES = {
  layout: "vertical",
  color: "gold",
  shape: "rect",
  label: "paypal",
  height: 50,
};
